import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'
import { Injectable, Injector } from '@angular/core'
import { Observable } from 'rxjs/Rx'
import { Router } from '@angular/router'
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch'
import { AuthenticationService } from './authentication.service'

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(private router: Router, private authenticationService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authenticationService.hasCompanySelected() && this.authenticationService.hasStoreSelected()) {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'bearer ' + localStorage.getItem('token'),
                    'StoreId': this.authenticationService.getStoreSelected(),
                    'CompanyId': this.authenticationService.getCompanySelected(),
                }
            })
        }
        else if (this.authenticationService.hasStoreSelected()) {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'bearer ' + localStorage.getItem('token'),
                    'StoreId': this.authenticationService.getStoreSelected()
                }
            })
        }
        else if (this.authenticationService.hasCompanySelected()) {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'bearer ' + localStorage.getItem('token'),
                    'CompanyId': this.authenticationService.getCompanySelected(),
                }
            })
        }
        else {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'bearer ' + localStorage.getItem('token')
                }
            })
        }


        return next.handle(req)
            .catch((error, caught) => {
                debugger
                if (error.status == 401) {
                    if (localStorage.getItem('token') != null && localStorage.getItem('storeMaskId') == null) {
                        this.router.navigate(['company']);
                        return Observable.throw(error);
                    }
                    else {
                        debugger
                        localStorage.removeItem('token');
                        this.router.navigate(['pages/login']);
                        return Observable.throw(error);
                    }
                } else {
                    return Observable.throw(error);
                }
            }) as any
    }
}
